import React from 'react';
import EnvironmentContext, {EnvironmentVariables} from './EnvironmentContext';

type EnvironmentProviderProps = React.PropsWithChildren<{environmentVars: EnvironmentVariables}>;

const EnvironmentProvider: React.FC<EnvironmentProviderProps> = ({environmentVars, children}) => (
  <EnvironmentContext.Provider value={environmentVars}>{children}</EnvironmentContext.Provider>
);

export default EnvironmentProvider;
